import { getAnalytics } from '../common/analytics';

const dataTrackLinks = document.querySelectorAll('a[data-track-link-name]');

Array.from(dataTrackLinks).forEach(dataTrackLink => {
  getAnalytics().trackLink(
    dataTrackLink,
    dataTrackLink.getAttribute('data-track-link-name'),
    JSON.parse(dataTrackLink.getAttribute('data-track-link-props'))
  );
});

// Generic link click tracking
// TOOD: convert links using data-track-link-name to data-tracking-event-name
const links = document.querySelectorAll('a:not([data-track-link-name])');

Array.from(links).forEach(link => {
  const linkTrackingParent = link.closest('*[data-tracking-event-name]');

  if (link.href && linkTrackingParent) {
    const eventName = linkTrackingParent.dataset.trackingEventName;
    let linkText = link.textContent.trim();
    const linkImg = link.querySelector('img');

    if (linkText === '' && linkImg) {
      linkText = linkImg.alt;
    }

    if (linkText !== '') {
      const eventProps = {
        referrer: document.referrer,
        path: window.location.pathname,
        link_url: link.href,
        link_text: linkText,
        has_image: !!linkImg,
      };

      // Attach a click handler to the link
      getAnalytics().trackLink(link, eventName, eventProps);
    }
  }
});
